import { render, staticRenderFns } from "./ModalDepositsSale.vue?vue&type=template&id=1f3eb3c2"
import script from "./ModalDepositsSale.vue?vue&type=script&lang=js"
export * from "./ModalDepositsSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports